import React, { FC, useState, KeyboardEvent, ChangeEvent } from "react";
import { Mui } from "@leap4/frontend";

const { TextField, Chip, Box } = Mui;

interface EmailChipsInputProps {
    emails: string[];
    setEmails: (emails: string[]) => void;
}

const EmailChipsInput: FC<EmailChipsInputProps> = ({ emails, setEmails }) => {
    const [inputValue, setInputValue] = useState("");

    const handleAddChip = () => {
        const trimmedValue = inputValue.trim();
        if (trimmedValue && validateEmail(trimmedValue) && !emails.includes(trimmedValue)) {
            setEmails([...emails, trimmedValue]);
            setInputValue("");
        }
    };

    const handleDeleteChip = (chipToDelete: string) => {
        setEmails(emails.filter((email) => email !== chipToDelete));
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAddChip();
        }
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const validateEmail = (email: string) => {
        // Basic email validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email.toLowerCase());
    };

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" flexWrap="wrap" gap={1}>
                {emails.map((email) => (
                    <Chip
                        key={email}
                        label={email}
                        onDelete={() => handleDeleteChip(email)}
                    />
                ))}
            </Box>
            <TextField
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Type an email and press Enter"
                variant="outlined"
                fullWidth
            />
        </Box>
    );
};

export default EmailChipsInput;
